import { CRM_PREFIX } from '@/config/api'
import type { RentalDateModel, RentalModel } from '@/types/models/RentalModel'
import { API_PREFIX } from '@rfc/rfc-components-library/config'
import { crm } from '@rfc/rfc-components-library/helpers'
import type { FilterType, PaginationType } from '@rfc/rfc-components-library/types'
import { buildQueryUrl } from '@rfc/rfc-components-library/utils'

const ORGANIZATIONS_ROUTE = '/organizations'

const BASE_ORGANIZATION_ROUTE = `${CRM_PREFIX}${ORGANIZATIONS_ROUTE}`

const ORGANIZATION_PREFIX = (organizationId: number) =>
    `${BASE_ORGANIZATION_ROUTE}/${organizationId}`

const ORGANIZATION_RENTALS_PREFIX = (organizationId: number) =>
    `${API_PREFIX}/organizations/${organizationId}/rentals`
const ORGANIZATION_DEVICE_RENTALS_PREFIX = (organizationId: number, deviceId: number) =>
    `${API_PREFIX}/organizations/${organizationId}/devices/${deviceId}/rentals`

const organizationApi = {
    // RENTALS
    createRental: (organizationId: number, data: Partial<RentalModel>) =>
        crm.post(`${ORGANIZATION_RENTALS_PREFIX(organizationId)}`, data),
    updateRental: (rentalId: number, organizationId: number, data: RentalDateModel) =>
        crm.put(`${ORGANIZATION_RENTALS_PREFIX(organizationId)}/${rentalId}`, data),
    endRental: (organizationId: number, rental_id: number) =>
        crm.delete(`${ORGANIZATION_RENTALS_PREFIX(organizationId)}/${rental_id}`),

    getDeviceRentalsHistory: (
        organizationId: number,
        deviceId: number,
        params?: Partial<PaginationType & RentalModel & FilterType>
    ) =>
        crm
            .get(
                `${ORGANIZATION_DEVICE_RENTALS_PREFIX(organizationId, deviceId)}${buildQueryUrl(
                    params,
                    true
                )}`
            )
            .then(res => res.data),
    endDeviceRental: (organizationId: number, deviceId: number, rentalId: number) =>
        crm
            .delete(`${ORGANIZATION_DEVICE_RENTALS_PREFIX(organizationId, deviceId)}/${rentalId}`)
            .then(res => res.data)
}

export default organizationApi
